export const THUMB_HEIGHT = 180;
